// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Segma/Segma-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Segma/Segma-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Segma/Segma-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Segma/Segma-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Segma/Segma-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Segma/Segma-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Segma/Segma-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Segma/Segma-ThinItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/Segma/Segma-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/Segma/Segma-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/Segma/Segma-MediumItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/Segma/Segma-SemiBoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/Segma/Segma-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/Segma/Segma-BlackItalic.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Segma";
  font-style: normal;
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: oblique;
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: oblique;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: oblique;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
    format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: oblique;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___})
    format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: oblique;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
    format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: oblique;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("opentype");
}

@font-face {
  font-family: "Segma";
  font-style: oblique;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("opentype");
}
`, "",{"version":3,"sources":["webpack://./../../packages/fonts/fonts.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+DAA4D;AAC9D;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+DAA8D;AAChE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+DAA6D;AAC/D;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+DAA4D;AAC9D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,+DAAiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,+DAAkE;AACpE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;sBACoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;sBACoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB;sBACoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gEAAiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gEAAkE;AACpE","sourcesContent":["@font-face {\n  font-family: \"Segma\";\n  font-style: normal;\n  font-weight: 100;\n  src: url(\"./fonts/Segma/Segma-Thin.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: normal;\n  font-weight: 300;\n  src: url(\"./fonts/Segma/Segma-Light.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"./fonts/Segma/Segma-Regular.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"./fonts/Segma/Segma-Medium.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"./fonts/Segma/Segma-SemiBold.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"./fonts/Segma/Segma-Bold.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: normal;\n  font-weight: 800;\n  src: url(\"./fonts/Segma/Segma-Black.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: oblique;\n  font-weight: 100;\n  src: url(\"./fonts/Segma/Segma-ThinItalic.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: oblique;\n  font-weight: 300;\n  src: url(\"./fonts/Segma/Segma-LightItalic.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: oblique;\n  font-weight: 400;\n  src: url(\"./fonts/Segma/Segma-RegularItalic.otf\")\n    format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: oblique;\n  font-weight: 500;\n  src: url(\"./fonts/Segma/Segma-MediumItalic.otf\")\n    format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: oblique;\n  font-weight: 600;\n  src: url(\"./fonts/Segma/Segma-SemiBoldItalic.otf\")\n    format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: oblique;\n  font-weight: 700;\n  src: url(\"./fonts/Segma/Segma-BoldItalic.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Segma\";\n  font-style: oblique;\n  font-weight: 800;\n  src: url(\"./fonts/Segma/Segma-BlackItalic.otf\") format(\"opentype\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
